import axios from '@/plugins/axios'

import treasureHuntModule from './modules/treasureHuntStore'
import saleagentByPersonModule from './modules/saleagentByPersonStore'
import saleagentListModule from './modules/saleagentListStore'
import saleagentRequestListModule from './modules/saleagentRequestListStore'
import andamandaStaffListPageModule from './modules/andamandaStaffListPage'
import ibeaconModule from './modules/ibeaconStore'
import ibeaconMessageModule from './modules/ibeaconMessageStore'
import productModule from './modules/productStore'
import customerModule from './modules/customerStore'
import bookingModule from './modules/bookingStore'
import walletModule from './modules/walletStore'
import wristbandModule from './modules/wristbandStore'
import appSettingsModule from './modules/appSettingsStore'
import ticketVisibilityModule from './modules/ticketVisibilityStore'
import nationalities from '../assets/nationalities.json'

export default {
    state: {
        username: localStorage.getItem('username') ?? '',
        nationalities: nationalities
    },

    mutations: {
        setAuthUser (state, user) {
            state.username = user.name
            localStorage.setItem('username', user.name)
        },

        setAccessToken (state, accessToken) {
            localStorage.setItem('accessToken', accessToken)
        }
    },
    actions: {
        async login ({ commit }, loginForm) {
            const response = await axios.post('login', loginForm)
            const { accessToken, user } = response
            commit('setAuthUser', user)
            commit('setAccessToken', accessToken)
        }
    },

    modules: {
        treasureHunt: treasureHuntModule,
        ibeacon: ibeaconModule,
        product: productModule,
        customer: customerModule,
        wallet: walletModule,
        wristband: wristbandModule,
        booking: bookingModule,
        ibeaconMessage: ibeaconMessageModule,
        saleagentByPerson: saleagentByPersonModule,
        saleagentList: saleagentListModule,
        saleagentRequestList: saleagentRequestListModule,
        andamandaStaffListPage: andamandaStaffListPageModule,
        appSettings: appSettingsModule,
        ticketVisibility: ticketVisibilityModule
    }
}
